const videoUrl = '/video';

export default videoUrl;
